import * as React from 'react';

function SvgMassage(props) {
  return (
    <svg width={10} height={11} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M8.5.5A1.5 1.5 0 0110 2v5a1.5 1.5 0 01-1.5 1.5H5.159l-2.656 1.955V8.5H1.5A1.5 1.5 0 010 7V2A1.5 1.5 0 011.5.5zm0 1h-7A.5.5 0 001 2v5a.5.5 0 00.5.5h1.003a1 1 0 011 1l-.002-.022 1.33-.978H8.5A.5.5 0 009 7V2a.5.5 0 00-.5-.5zM7.216 4c.33 0 .609.28.609.625s-.28.625-.61.625c-.36 0-.64-.28-.64-.625S6.855 4 7.215 4zM2.84 4c.33 0 .609.28.609.625s-.28.625-.61.625c-.36 0-.64-.28-.64-.625S2.48 4 2.84 4zm2.187 0c.33 0 .61.28.61.625s-.28.625-.61.625c-.36 0-.64-.28-.64-.625S4.668 4 5.028 4z" />
    </svg>
  );
}

export default SvgMassage;
